import React from "react";

import classes from "./styles.module.scss";
import { Button, ModalBody } from "Components/ReactstrapSlim";
import CloseButton from "../../CloseButton";
import List from "../../List";
import classNames from "classnames";

interface ModalBodyBookProps {
   toggle(): void;
}

const ModalBodyBook: React.FC<ModalBodyBookProps> = ({ toggle }) => {
   const showSupportChat = () => {
      toggle();
      LSHelper.HelperLib.openSupportChat();
   }

   return <ModalBody className={classes.modalBody}>
      <CloseButton toggle={toggle} />
      <div className={classes.header}>
         <div className={classes.header1}>
            Find workspace–
         </div>
         <div className={classes.header2}>
            by the hour, day, month or longer.
         </div>
      </div>
      <List
         className={classes.list}
         items={[
            {
               title: "Browse and search:",
               description: "Filter space by location, space type, capacity, amenities, price, and more."
            },
            {
               title: "Book it:",
               description: "Secure your space with your preferred payment method."
            },
            {
               title: "Access it:",
               description: "Keep an eye out for your confirmation details–it's that easy!"
            }
         ]}
      />
      <div className={classes.buttons}>
         <a className={classNames("btn btn-primary btn-lg", classes.cta)} href="/search">Find Space Now</a>
         <Button color="link" className={classes.btnSupport} size="lg" onClick={showSupportChat}>Contact Support</Button>
      </div>
   </ModalBody>
}

export default ModalBodyBook;